import { IParameterGroup } from '@/pages/Parameters/parameters.types.ts'
import useParameterGroup from '@/pages/Parameters/hooks/useParameterGroup.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import parametersApi from '@/pages/Parameters/parameters.api.ts'
import parameterGroupsEvents from '@/pages/Parameters/events/groups/paramterGroups.events.ts'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import ParameterGroupDropdown from '@/pages/Parameters/components/ParameterGroupDropdown'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import SeparateLine from '@/shared/Forms/SeparateLine'

interface IProps {
  groupId: IParameterGroup['id']
  open: boolean
  onClose: () => void
}

const EditParameterGroupModal = (props: IProps) => {
  const group = useParameterGroup(props.groupId)
  const { wait, loading } = useHttpLoader()
  const [draft, setDraft, handleChange] = useStateWithChange<IParameterGroup>(group)

  useEffect(() => {
    setDraft(group)
  }, [group])

  const handleSave = () => {
    wait(parametersApi.updateGroup(draft), (resp) => {
      if (resp.status === 'success') {
        parameterGroupsEvents.updated(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Редактирование группы" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Вышестоящая группа">
          <ParameterGroupDropdown
            name="parentId"
            wrapperStyle={{ height: '32px' }}
            onChange={handleChange}
            value={draft.parentId}
            title="Выберите группу"
          />
        </FormField>
        <FormField label="Наименование группы" required>
          <TextInput name="name" onChange={handleChange} value={draft.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Сохранить" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default (props: IProps) => {
  if (!props.groupId) return null

  return <EditParameterGroupModal {...props} />
}
